<template>
  <div>
    <v-data-table
      :headers="sms_setting.sms_service ? headers_with_sms : headers"
      :items="list"
      :loading="loading"
      sort-by="calories"
      :loading-text="$table_loading_text"
      :page.sync="page"
      :items-per-page="filter.item_per_page"
      hide-default-footer
      show-select
      item-key="_id"
      v-model="selected"
      @input="$emit('on-selected', selected)"
    >
      <template v-slot:[`item._id`]="{ item }">
        {{
          list
            .map(function (x) {
              return x._id;
            })
            .indexOf(item._id) +
          1 +
          filter.item_per_page * (filter.page - 1)
        }}
      </template>

      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>
      <template v-slot:[`item.parcel_delivery`]="{ item }">
        <v-icon v-if="item.parcel_delivery">mdi-check</v-icon>
        <v-icon v-else>mdi-close</v-icon>
      </template>

      <template v-slot:[`item.transportation_product`]="{ item }">
        <v-icon v-if="item.tax_data.transportation_product.length > 0">
          mdi-check
        </v-icon>
        <v-icon v-else>mdi-close</v-icon>
      </template>

      <!-- <template v-slot:[`item.sms_job_done`]="{ item }">
        <v-btn
          v-show="false"
          v-if="!item.tax_data.sms_job_done"
          color="primary"
          small
          outlined
          @click="updateStatus(item._id, 0)"
        >
          กดเพื่อส่ง
        </v-btn>
        <v-btn
          v-show="false"
          v-if="item.tax_data.sms_job_done"
          color="primary"
          small
        >
          ส่งแล้ว
        </v-btn>
      </template> -->
      <template v-slot:[`item.tel_alert`]="{ item }">
        <div v-if="item.tax_data.is_call_alert">
          <v-btn
            v-if="item.tax_data.tel_alert == '0'"
            color="error"
            small
            outlined
            @click="updateStatus(item._id, 1)"
          >
            ต้องการให้โทร
          </v-btn>
          <v-btn v-else color="primary" small @click="updateStatus(item._id, 1)">
            โทรแล้ว {{ item.tax_data.tel_alert }} ครั้ง
          </v-btn>
        </div>
        <div v-if="!item.tax_data.is_call_alert">
          <v-btn color="primary" small outlined>ไม่ต้อง</v-btn>
        </div>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-tooltip v-if="item.status" bottom max-width="320" open-delay="100">
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              small
              label
              :color="smsStatusStyle(item.status).color"
              :text-color="smsStatusStyle(item.status).text"
              data-test="sms-status"
            >
              <v-icon left x-small>{{ smsStatusStyle(item.status).icon }}</v-icon>
              {{ item.status }}
            </v-chip>
          </template>
          <div data-test="sms-status-hint">{{ smsStatusStyle(item.status).hint }}</div>
          <div v-if="smsStatusStyle(item.status).contact" class="mt-1" data-test="sms-status-contact">
            หากต้องการความช่วยเหลือ ติดต่อเรา LINE: <b>{{ SMS_SUPPORT_LINE }}</b>
          </div>
        </v-tooltip>
        <v-progress-circular
          v-else-if="smsChecking && needsSmsCheck(item)"
          indeterminate
          size="16"
          width="2"
          color="grey"
        />
      </template>

      <template v-slot:[`item.pick_up_date`]="{ item }">
        <v-btn
          v-if="item.tracking_status != 3"
          color="success"
          small
          outlined
          @click="openReceivedDialog(item._id)"
        >
          รับเล่มคลิก
        </v-btn>
        <v-btn v-else color="success" small>รับเล่มแล้ว</v-btn>
      </template>

      <template v-slot:[`item.margin`]="{ item }">
        <div class="red--text">{{ item.tax_data.margin }}</div>
      </template>

      <template v-slot:[`item.margin_minus`]="{ item }">
        <div v-if="item.margin_minus" class="red--text text-center">
          {{ item.margin_minus | numeral('0,0.00') }}
        </div>
        <div v-else class="text-center">-</div>
      </template>

      <template v-slot:[`item.margin_plus`]="{ item }">
        <div v-if="item.margin_plus" class="success--text text-center">
          {{ item.margin_plus | numeral('0,0.00') }}
        </div>
        <div v-else class="text-center">-</div>
      </template>

      <template v-slot:[`item.customer_phone_number`]="{ item }">
          {{ phoneNumberFormat(item.customer_phone_number) }}
      </template>

      <template v-slot:footer>
        <cursor-pager
          :page="filter.page"
          :items-per-page="filter.item_per_page"
          :can-previous="cursorHistory.length > 1"
          :can-next="hasMore"
          :loading="loading"
          @previous="goPreviousPage"
          @next="goNextPage"
          @change-items-per-page="changePageSize"
        />
      </template>
    </v-data-table>

    <v-dialog persistent scrollable max-width="800" v-model="dialogForm">
      <CompleteForm
        :item="dialogFormData"
        @onClose="(dialogForm = false), getData()"
      />
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      max-width="800"
      v-model="dialogReceivedForm"
    >
      <ReceivedForm
        :item="dialogReceivedFormData"
        @onClose="(dialogReceivedForm = false), getData()"
      />
    </v-dialog>
  </div>
</template>

<script>
import permissionConsumer from '@/mixins/permissionConsumer';
import listFilterMixin from './listFilterMixin';
import CompleteForm from './CompleteForm';
import ReceivedForm from './ReceivedForm';
import * as moment from 'moment';

const SMS_STATUS_TEXT = {
  SUCCESS: 'ส่งสำเร็จ',
  FAILED: 'ล้มเหลว',
  PROCESSING: 'กำลังส่ง',
  EXPIRED: 'ล้มเหลว',
  BLOCKED: 'ลูกค้าบล็อก SMS',
};
const SMS_FINAL_STATUSES = ['SUCCESS', 'FAILED', 'EXPIRED', 'BLOCKED'];
const SMS_SUPPORT_LINE = 'p9944';
// Background / text colour and icon of the status chip (the text and icon carry the meaning too),
// and the tooltip text. `contact` adds the support LINE for statuses the shop cannot fix alone.
// Plain hex colours on purpose: this app's Vuetify theme redefines `green` and `red`, so the
// palette class names (e.g. "green lighten-5") do not give the usual shades.
const SMS_STATUS_STYLE = {
  'ส่งสำเร็จ': {
    color: '#E8F5E9', text: '#2E7D32', icon: 'mdi-check-circle',
    hint: 'ข้อความ SMS ส่งถึงเครื่องลูกค้าแล้ว',
  },
  'กำลังส่ง': {
    color: '#FFF3E0', text: '#E65100', icon: 'mdi-clock-outline',
    hint: 'ข้อความ SMS อยู่ระหว่างการส่งถึงลูกค้า สถานะจะอัปเดตเมื่อเปิดหน้านี้อีกครั้ง',
  },
  'ล้มเหลว': {
    color: '#FDECEA', text: '#C62828', icon: 'mdi-close-circle', contact: true,
    hint: 'ข้อความ SMS ส่งไม่ถึงลูกค้า (ส่งไม่สำเร็จ หรือหมดอายุก่อนถึงเครื่อง) อาจเกิดจากเบอร์ลูกค้าไม่ถูกต้อง/ปิดเครื่อง หรือเครดิต SMS ของร้านไม่พอ ลองตรวจเบอร์ลูกค้าและเครดิตกับผู้ให้บริการ SMS',
  },
  'ลูกค้าบล็อก SMS': {
    color: '#F3E5F5', text: '#7B1FA2', icon: 'mdi-cancel',
    hint: 'เบอร์ของลูกค้าบล็อกข้อความจากผู้ส่ง จึงไม่ได้รับ SMS ควรแจ้งลูกค้าทางโทรศัพท์แทน',
  },
  'ไม่เชื่อมต่อ': {
    color: '#EEEEEE', text: '#616161', icon: 'mdi-link-off', contact: true,
    hint: 'ไม่มีบันทึกการส่ง SMS ของงานนี้ อาจเพราะตอนงานเสร็จร้านยังไม่ได้เปิดส่ง SMS อัตโนมัติ, เบอร์ลูกค้าไม่ครบ 10 หลัก, หรือระบบส่งไม่สำเร็จ (ไม่ได้หมายถึงปัญหาการเชื่อมต่ออินเทอร์เน็ต) ถ้าแน่ใจว่าส่ง SMS แล้ว ให้แจ้งทะเบียนรถของงานนี้',
  },
  'ข้อผิดพลาดในการดึงข้อมูล': {
    color: '#ECEFF1', text: '#455A64', icon: 'mdi-alert-circle-outline', contact: true,
    hint: 'ตอนนี้ระบบเช็กสถานะกับผู้ให้บริการ SMS ไม่สำเร็จ (ไม่ได้แปลว่า SMS ส่งไม่ถึงลูกค้า) ลองรีเฟรชหน้านี้อีกครั้ง',
  },
};
const SMS_STATUS_STYLE_UNKNOWN = {
  color: '#EEEEEE', text: '#616161', icon: 'mdi-help-circle-outline', contact: true,
  hint: 'ผู้ให้บริการ SMS ส่งสถานะที่ระบบยังไม่รู้จักกลับมา โปรดแจ้งทะเบียนรถของงานนี้',
};
const SMS_BATCH = 50; // jobs per request, the backend's limit

export default {
  components: {
    CompleteForm,
    ReceivedForm,
  },
  mixins: [permissionConsumer, listFilterMixin],
  data: () => ({
    sms_job_done: false,
    dialogForm: false,
    dialogFormData: null,
    dialogReceivedForm: false,
    dialogReceivedFormData: null,

    selected: [],
    loading: true,
    page: 1,
    list: [],
    sms_setting: {},
    smsChecking: false,
    SMS_SUPPORT_LINE,
    item: {
      process_array: [],
    },
    headers: [
      { text: 'ลำดับ', value: '_id', filterable: false },
      { text: 'วันที่', value: 'date', filterable: false },
      { text: 'ทะเบียน', value: 'car_plate', filterable: false },
      { text: 'จังหวัด', value: 'province', filterable: false },
      { text: 'ส่งพัสดุ', value: 'parcel_delivery', filterable: false },
      { text: 'งานขนส่ง', value: 'transportation_product', filterable: false },
      // { text: 'SMS', value: 'sms_job_done', filterable: false },
      { text: 'โทรแจ้งลูกค้า', value: 'tel_alert', filterable: false },
      { text: 'รับเล่ม', value: 'pick_up_date', filterable: false },
      { text: 'เบอร์โทร', value: 'customer_phone_number', filterable: false },
      { text: 'เก็บเพิ่ม', value: 'margin_minus', filterable: false },
      { text: 'คืนเงิน', value: 'margin_plus', filterable: false },
      { text: 'โน๊ต', value: 'note', filterable: false },
      { text: '', value: 'actions', filterable: false },
      // {
      //   text: 'สถานะ SMS',
      //   value: 'status',
      //   filterable: false,
      // },
    ],
    headers_with_sms: [
      { text: 'ลำดับ', value: '_id', filterable: false },
      { text: 'วันที่', value: 'date', filterable: false },
      { text: 'ทะเบียน', value: 'car_plate', filterable: false },
      { text: 'จังหวัด', value: 'province', filterable: false },
      { text: 'ส่งพัสดุ', value: 'parcel_delivery', filterable: false },
      { text: 'งานขนส่ง', value: 'transportation_product', filterable: false },
      // { text: 'SMS', value: 'sms_job_done', filterable: false },
      { text: 'โทรแจ้งลูกค้า', value: 'tel_alert', filterable: false },
      { text: 'รับเล่ม', value: 'pick_up_date', filterable: false },
      { text: 'เบอร์โทร', value: 'customer_phone_number', filterable: false },
      { text: 'เก็บเพิ่ม', value: 'margin_minus', filterable: false },
      { text: 'คืนเงิน', value: 'margin_plus', filterable: false },
      { text: 'โน๊ต', value: 'note', filterable: false },
      { text: '', value: 'actions', filterable: false },
      {
        text: 'สถานะ SMS',
        value: 'status',
        filterable: false,
      },
    ],
    isCar: true,
    showPhoneNumber: false,
    filter: {
      branch_id: null,
      tracking_type: 0,
      tracking_status: 2,
      tax_renewal_round: '',
      car_type_filter: 0,
      item_per_page: 20,
      page: 1,
      start_with: '',
    },
  }),
  beforeDestroy() {
    this.isGone = true;
  },
  async mounted() {
    this.filter.branch_id = this.$store.state.selected_branch._id;
    await this.getSmsSetting();
    await this.getData();
    await this.getShowPhoneNumber();
  },
  methods: {
    async getSmsSetting() {
      let filter = {
        branch_id: this.$store.state.selected_branch._id,
      };
      let body = {
        token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/branch/get_sms_setting`, body)
        .then(async (res) => {
          this.sms_setting = res.result;
        });
    },
    async getData() {
      this.loading = true;
      let body = {
        token: this.$jwt.sign(this.filter, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/get_process`, body)
        .then((res) => {
          this.list = this.prepareProcessArray(res.result.data);
          this.applyPageResult(res.result);
          this.totalTax = res.result.total_tax;
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
      this.loading = false;
      // The SMS delivery status is only needed while this tab is the visible one,
      // and the table does not wait for it. It is read for every branch that has the SMS
      // service on (also when auto-send is off: earlier SMS still have a status).
      if (this.sms_setting.sms_service && this.active) {
        this.refreshSmsStatus();
      }
    },
    async getShowPhoneNumber() {
      await this.$store.dispatch('getGroupPermissions');
      this.applyGroupPermissions();
    },
    applyGroupPermissions() {
      try {
        this.show_phone_number = this.$store.state.group_permissions.show_phone_number;
        if (!this.show_phone_number) {
          this.showPhoneNumber = false;
        } else {
          this.showPhoneNumber = true;
        };
      } catch (error) {
        this.showPhoneNumber = false;
        console.error('Error in getShowPhoneNumber:', error);
      };
    }, 
    phoneNumberFormat(val) {
      if (val) {
        if (!this.showPhoneNumber) return 'XXX-XXXXXXX';
        return val.substring(0, 3) + '-' + val.substring(3, val.length);
      } else return val;
    },
    // Text for a status code from /process/get_sms_delivery_status
    smsStatusStyle(text) {
      return SMS_STATUS_STYLE[text] || SMS_STATUS_STYLE_UNKNOWN;
    },
    smsStatusText(status) {
      if (status === 'NO_TRANSACTION' || status === 'NO_SERVICE') return 'ไม่เชื่อมต่อ';
      if (status === 'ERROR') return 'ข้อผิดพลาดในการดึงข้อมูล';
      return SMS_STATUS_TEXT[status] || 'สถานะไม่รู้จัก';
    },
    // What is already stored on the job (no request needed)
    storedSmsStatus(item) {
      const tax = item.tax_data || {};
      if (!tax.sms_transaction_id) return 'ไม่เชื่อมต่อ';
      const saved = tax.sms_delivery;
      if (saved && saved.transaction_id === tax.sms_transaction_id && saved.status) {
        return this.smsStatusText(saved.status);
      }
      return '';
    },
    // Only jobs whose SMS has no final status stored yet need to be asked about
    needsSmsCheck(item) {
      const tax = item.tax_data || {};
      if (!tax.sms_transaction_id) return false;
      const saved = tax.sms_delivery;
      return !(
        saved &&
        saved.transaction_id === tax.sms_transaction_id &&
        SMS_FINAL_STATUSES.includes(saved.status)
      );
    },
    // The backend asks the SMS provider (the API keys never reach the browser) and stores final statuses
    async refreshSmsStatus() {
      const items = this.list.filter(this.needsSmsCheck);
      this.smsChecking = items.length > 0;
      try {
        for (let i = 0; i < items.length; i += SMS_BATCH) {
          if (!this.active || this.isGone) return;
          const chunk = items.slice(i, i + SMS_BATCH);
          const body = {
            token: this.$jwt.sign(
              { process_array: chunk.map((x) => x._id) },
              this.$privateKey,
              { noTimestamp: true }
            ),
          };
          try {
            const res = await this.$axios.post(
              `${this.$baseUrl}/process/get_sms_delivery_status`,
              body
            );
            if (!this.active || this.isGone) return;
            for (const item of chunk) {
              const answer = res.result && res.result[item._id];
              item.status = this.smsStatusText(answer ? answer.status : 'ERROR');
            }
          } catch (err) {
            console.log('err', err);
            chunk.forEach((item) => {
              item.status = this.smsStatusText('ERROR');
            });
          }
        }
      } finally {
        this.smsChecking = false;
      }
    },
    formatDate(date) {
      if (!date) return '';
      let year = parseInt(moment(date).format('YYYY'));
      let m_d = moment(date).format('DD/MM');
      return `${m_d}/${year + 543}`;
    },

    openDialog() {
      this.dialogForm = true;
    },
    closeDialog() {
      this.dialogForm = false;
      this.getData();
    },

    async openReceivedDialog(id) {
      let body = {
        token: this.$jwt.sign({ process_id: id }, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/get_by_id`, body)
        .then((res) => {
          this.dialogFormData = res.result;
          this.dialogForm = true;
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
    },

    cancel() {},
    prepareProcessArray(process_array) {
      let list = [];
      if (
        process_array &&
        process_array.length &&
        typeof process_array === 'object'
      ) {
        for (var i = 0; i < process_array.length; i++) {
          var o = Object.assign({}, process_array[i]);
          o.tax_data.is_call_alert =
            'is_call_alert' in o.tax_data ? o.tax_data.is_call_alert : false;
          // declared here so the column updates when the status arrives
          o.status = this.sms_setting.sms_service ? this.storedSmsStatus(o) : '';
          list.push(o);
        }
      }
      return list;
    },
    async updateStatus(id, btnAction, value) {
      // btnAction => 0 = sms, 1 = call
      if (btnAction == 0) {
        console.log('sms');
        this.loading = true;
        await this.$axios
          .post(`${this.$baseUrl}/process/get_by_id`, {
            token: this.$jwt.sign({ process_id: id }, this.$privateKey, {
              noTimestamp: true,
            }),
          })
          .then(async (res) => {
            let oldData = res.result;
            oldData.tax_data.sms_job_done = true;

            // fill old data to edit payload
            let payload = {
              process_id: id,
              tax_data: oldData.tax_data,
              insurance_data: oldData.insurance_data,
              transport_data: oldData.transport_data,
              is_succes: oldData.is_success,
              reason_on_fail: oldData.reason_on_fail,
              reciever_name: oldData.reciever_name,
              note: oldData.note,
            };
            await this.$axios
              .post(`${this.$baseUrl}/process/edit_process`, {
                token: this.$jwt.sign(payload, this.$privateKey, {
                  noTimestamp: true,
                }),
              })
              .then((res) => {
                this.getData();
              })
              .catch((err) => {
                console.log('err', err);
                this.$alertServerError({ title: err.error_message });
              });
          })
          .catch((err) => {
            console.log('err', err);
            this.$alertServerError({ title: err.error_message });
          });
        this.loading = false;
      } else if (btnAction == 1) {
        console.log('call');
        this.loading = true;
        // get old data
        await this.$axios
          .post(`${this.$baseUrl}/process/get_by_id`, {
            token: this.$jwt.sign({ process_id: id }, this.$privateKey, {
              noTimestamp: true,
            }),
          })
          .then(async (res) => {
            let oldData = res.result;
            oldData.tax_data.tel_alert =
              oldData.tax_data.tel_alert < 3
                ? oldData.tax_data.tel_alert + 1
                : 0;
            // fill old data to edit payload
            let payload = {
              process_id: id,
              tax_data: oldData.tax_data,
              insurance_data: oldData.insurance_data,
              transport_data: oldData.transport_data,
              is_succes: oldData.is_success,
              reason_on_fail: oldData.reason_on_fail,
              reciever_name: oldData.reciever_name,
              note: oldData.note,
            };
            await this.$axios
              .post(`${this.$baseUrl}/process/edit_process`, {
                token: this.$jwt.sign(payload, this.$privateKey, {
                  noTimestamp: true,
                }),
              })
              .then((res) => {
                this.getData();
              })
              .catch((err) => {
                console.log('err', err);
                this.$alertServerError({ title: err.error_message });
              });
          })
          .catch((err) => {
            console.log('err', err);
            this.$alertServerError({ title: err.error_message });
          });
        this.loading = false;
      }
    },
  },
  computed: {},
  watch: {
    status(nv, ov) {
      if (nv != ov) {
        this.item.start_with = nv;
        this.getData();
      }
    },
  },
};
</script>
